import { useTranslation } from "react-i18next";
import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { Search, User, ChevronDown } from "../icons";
import KBLogo from "../../assets/logo/kb-logo.png";
import { Switcher } from ".";
import { DirectoryAPI } from "@api";
import { useState, useEffect } from "react";
import styled from "styled-components";

const ContainerStyle = {
  position: "fixed",
  width: "100%",
  background: "#fff",
  zIndex: 2,
};

const BottomNavItemLabel = styled.div`
  color: #f2a900;
  font-weight: bold;
`;

const BottomNavItemContent = styled.ul`
  list-style: none;
  padding: 1em 0;

  & li {
    border-bottom: #ededed solid 1px;
    padding-bottom: 0.8rem;
    padding-top: 0.2rem;

    &:hover {
      color: #f2a900;
      cursor: pointer;
    }
  }
`;

const BottomNavItemContentContainer = styled.div`
  border-right: gainsboro solid 1px;
  padding: 0.5em 1.5em;
  text-align: left;
`;

const BottomNavContainer = styled.div``;

const Navigation = function () {
  const [directory, setDirectory] = useState(null);
  const [subdirectory, setSubdirectory] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const loadData = async function () {
      const directoryData = await DirectoryAPI();
      setDirectory(directoryData.data["header"]);
    };
    if (!directory) {
      loadData();
    }
  }, [directory]);

  const onDirectoryClick = (props) => {
    if (!subdirectory || subdirectory !== directory[props]) {
      setSubdirectory(directory[props]);
    } else {
      setSubdirectory(null);
    }
  };

  return (
    <div fixed="top" style={ContainerStyle}>
      <Navbar className="shadow-sm p-2 bg-white" expand="lg">
        <Navbar.Brand href="/">
          <img
            src={KBLogo}
            width="30"
            height="30"
            className="d-inline-block align-top"
            alt="KB Bank"
          />
          <span className="m-2">KB Bank</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto">
            <Switcher />
          </Nav>
          <Nav>
            {directory != null
              ? directory.map((data, i) => {
                  return !data.child ? (
                    <Nav.Link href="#" key={i}>
                      {data.label}
                    </Nav.Link>
                  ) : (
                    <div key={i}>
                      {/* It will show on desktop */}
                      <Nav.Link
                        href="#"
                        onClick={() => onDirectoryClick(i)}
                        className="d-none d-xl-block"
                      >
                        {data.label} <ChevronDown fill="rgba(0,0,0,.55)" />
                      </Nav.Link>

                      {/* It will show on mobile */}
                      <NavDropdown
                        title={data.label}
                        id={`collasible-nav-dropdown-${i}`}
                        key={i}
                        onClick={() => onDirectoryClick(i)}
                        className="d-xl-none"
                      >
                        {data.child.map((data, i) => {
                          return !data.child ? (
                            <NavDropdown.Item href={data.link} key={i}>
                              {data.label}
                            </NavDropdown.Item>
                          ) : (
                            <div key={i}>
                              <NavDropdown.Header href={data.link}>
                                {data.label}
                              </NavDropdown.Header>
                              {data.child.map((data, i) => {
                                return (
                                  <NavDropdown.Item href={data.link} key={i}>
                                    {data.label}
                                  </NavDropdown.Item>
                                );
                              })}
                            </div>
                          );
                        })}
                      </NavDropdown>
                    </div>
                  );
                })
              : ""}

            <Button variant="outline-default" className="mx-4">
              <Search fill="#000" />
            </Button>
            <Button variant="warning">
              <User fill="#000" className="mx-1" /> <span>{t('in')}</span>
              <ChevronDown className="mx-1" />
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {!!subdirectory ? (
        <BottomNavContainer className="py-4 shadow-sm bg-white">
          <div className="row">
            {subdirectory.child.map((data, i) => {
              return (
                <BottomNavItemContentContainer key={i} className="col-sm-3">
                  <BottomNavItemLabel>{data.label}</BottomNavItemLabel>
                  {!data.child ? (
                    ""
                  ) : (
                    <BottomNavItemContent key={i}>
                      {data.child.map((data, i) => {
                        return <li key={i}>{data.label}</li>;
                      })}
                    </BottomNavItemContent>
                  )}
                </BottomNavItemContentContainer>
              );
            })}
          </div>
        </BottomNavContainer>
      ) : (
        ""
      )}
    </div>
  );
};

export default Navigation;
